/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Divider, Flex, Icon, Menu, MenuButton, MenuItem, Text, View } from "@aws-amplify/ui-react";
import { Grid, useMediaQuery } from "@mui/material";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import Modal from 'react-modal'
import { motion } from "framer-motion"
import { getUser } from "../apigateway/mongocalls";
import { useAuthStore, useUserStore } from "store";
import { getCheckoutSession, getPortalSession } from "apigateway/stripecalls";
import { SkewLoader } from "react-spinners";



export default function Personalaccountnavbar(props) {
  const { user } = props;
  const matches = useMediaQuery('(min-width:100px)');
  const usermatches = useMediaQuery('(min-width:500px)');
  const [subscribed, setsubscribed] = React.useState(false);
  const [customerid, setcustomerid] = React.useState("");
  const { authToken, refreshToken } = useAuthStore();
  const { setUserdb } = useUserStore();
  


  React.useEffect(() => {
    const currentUser = async () => {
    if(user){
    const sub = user.attributes.sub

      try {  
      if(authToken){
      // console.log('token exist - get user from db...');
      const realmuser = await getUser(sub, authToken);
      // console.log('get user response', realmuser);
 
      if(realmuser.stripe_id){
      // console.log("user", realmuser)
      setUserdb(realmuser);
      setcustomerid(realmuser.stripe_id)
      const allagents = realmuser.all_agents
      setsubscribed(allagents)
      return
       }

      // Refresh Token - Resend 
      if(realmuser === 'refresh token'){
              // console.log('refresh token from account nav...')
                const refreshResp = await refreshToken();
                if(refreshResp){
                // console.log('refreshed auth token?', refreshResp);
                const realmuser = await getUser(sub, refreshResp);
                if(realmuser.stripe_id){
                  // console.log("user captured after refresh...")
                  setUserdb(realmuser);
                  setcustomerid(realmuser.stripe_id)
                  const allagents = realmuser.all_agents
                  setsubscribed(allagents)
                  return
                }
                return
                }
              return
        }

      }

      
      } catch (error) {
        console.log(error)
      }
     }
    }

    currentUser()
  }, [user, authToken])
  
  const [clickedProject, setclickedProject] = React.useState(false)
    const closeProject = async () => {
        setclickedProject(false)     
    }
  
  const navigate = useNavigate()


  const signOut = async () => {
    await Auth.signOut()
    navigate('/')
  }

  const navAbout = async () => {
    navigate('/')
  }


  const [subloading, setsubloading] = React.useState(false);

  const subscribenow = async () => {
    setsubloading(true);
  
    if(subscribed === false){
  
    const url = await getCheckoutSession(customerid);
    setsubloading(false);
  
    window.location.href = url
  }

  if(subscribed === true){
  
    const url = await getPortalSession(customerid);
     setsubloading(false);
  
    window.location.href = url
  }
  
  }


  
  return (


    <View
    className="fixed flex justify-between items-center w-full h-[75px] bg-[rgba(225,255,255,.3)] z-10"
    // container
      // // width="100vw"
      // height="75px"
      // display="flex"

      // gap="unset"
      // alignItems="center"
      // justifyContent="center"
      // position="absolute"
      // boxShadow="0px 5px 15px rgba(0, 0, 0, 0.10000000149011612)"
      // // padding="0px 0px 0px 0px"
      // zIndex="9"
      // paddingLeft="20px"
      // paddingRight="6px"
      // // backgroundColor="rgba(222,136,101,.5)"
      // backgroundColor="rgba(225,255,255,.3)"
      // wrap="nowrap"
      // backgroundColor="rgba(255,255,255,1)"
      // {...getOverrideProps(overrides, "Personalaccountnavbar")}
      // {...rest}
    >
      {/* <View
        padding="0px 0px 0px 0px"
        width="1440px"
        height="90px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="relative"
        top="0%"
        bottom="0%"
        left="0%"
        right="0%"
        {...getOverrideProps(
          overrides,
          "Personal account, default no notifcation"
        )}
      > */}

        {/* <View
          width="1440px"
          height="90px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0%"
          bottom="0%"
          left="0%"
          right="0%"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "base")}
        ></View> */}

        {/* <Icon
          width="40px"
          height="0px"
          viewBox={{ minX: 0, minY: 0, width: 1, height: 40 }}
          paths={[
            {
              d: "M0 0L40 0L40 -1L0 -1L0 0Z",
              stroke: "rgba(19,42,83,0.1)",
              fillRule: "nonzero",
              strokeWidth: 1,
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="27.78%"
          bottom="72.22%"
          left="79.17%"
          right="18.06%"
          transformOrigin="top left"
          transform="rotate(90deg)"
          {...getOverrideProps(overrides, "Divider")}
        ></Icon> */}


        
          <Grid container
             position="relative"
             width="250px"
             height="auto"
             

             display={matches ? "flex" : "none" }
             justifyContent="flex-start"
             alignItems="center"
             paddingLeft="20px"
             top="-1px"
             gap="15px"
            //  backgroundColor="red"
             wrap="nowrap"
             >


              <a href="#Project">
              <motion.button
        whileHover={{scale : 1.1}}
        whileTap={{scale: 0.9}}
        
        >
              <Text
                fontFamily="Nunito"
                variation="link"
                fontSize="16px"
                fontWeight="700"
                color="white"
                lineHeight="21.823999404907227px"
                textAlign="left"
                // display={matches ? "block" : "none"}
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                // backgroundColor="red"
                children="Projects"
                
                className="hover:cursor-pointer"
              
              ></Text>
              </motion.button>
              </a>
            
             
                <a href="#Agents">
                <motion.button
        whileHover={{scale : 1.1}}
        whileTap={{scale: 0.9}}
        
        >
               <Text
                fontFamily="Nunito"
                fontSize="16px"
                fontWeight="700"
                color="white"
                lineHeight="21.823999404907227px"
                textAlign="left"
                // display={matches ? "block" : "none"}
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                // backgroundColor="red"
                children="Agents"
                className="hover:cursor-pointer"
                // onClick={()=>{
                //   setclickedProject(true)
                // }}
               
              
              ></Text>
              </motion.button>
              </a>

              {subloading ? 
               <View className="relative flex  justify-center items-center h-full w-full  ">
          <View className='relative block w-[20px] h-[20px] '>
            <SkewLoader
              loading="true"
              // color='#de8865cc'
      
            color='white'
            size="20px"
          /> 
        </View>
        </View> : <></>}
            
          </Grid>

          

          <Grid container item
            gap="8px"
            direction="row"
            width="100%"
            height="100%"
            justifyContent="flex-end"
            alignItems="center"
            // shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            // backgroundColor="green"
            wrap="nowrap"
            // {...getOverrideProps(overrides, "Profile ")}
          >
            {/* <Icon
              width="48px"
              height="48px"
              viewBox={{ minX: 0, minY: 0, width: 48, height: 48 }}
              paths={[
                {
                  d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z",
                  fill: "rgba(196,196,196,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              shrink="0"
              position="relative"
              {...getOverrideProps(overrides, "Ellipse 20")}
            ></Icon> */}
            <Text
              fontFamily="Nunito"
              fontSize="16px"
              fontWeight="700"
              color="white"
              lineHeight="21.823999404907227px"
              textAlign="left"
              display={usermatches ? "block" : "none"}
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              // backgroundColor="red"
              children={user?.attributes?.email}
              // {...getOverrideProps(overrides, "Sam Miller")}
            ></Text>
              
            <Text
            position="relative"
            paddingLeft="5px"
            fontWeight="semibold"
            // backgroundColor="red"
            justifyContent="center"
            color="white"
            
            // wrap="nowrap"
            textAlign="center"
            // style={{
            //   wrap: "nowrap"
            // }}
            display={subscribed ? "flex" : "none"}>
            {`GateLeak Pro 🎉`}
            </Text>

             <Menu
                // triggerClassName="my-menu-trigger"
                className="my-menu-content"
                menuAlign="end"
                width="200px"
                height="auto"
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                marginTop="10px"
                trigger={

                <MenuButton
                className="my-menu-trigger"
                
                borderRadius='5px'
                
                 >
                    <Icon
                  width="13.5px"
                  height="6.66px"
                  viewBox={{
                    minX: 0,
                    minY: 0,
                    width: 13.5,
                    height: 6.662109375,
                  }}
                  paths={[
                    {
                      d: "M0.21913 0.220211C0.511724 -0.0729808 0.986598 -0.0734649 1.27979 0.21913L5.01935 3.95108C5.4238 4.3547 5.69564 4.62517 5.92172 4.81672C6.14109 5.00259 6.26763 5.06987 6.36421 5.10121C6.61497 5.18257 6.88503 5.18257 7.13579 5.10121C7.23237 5.06987 7.35891 5.00259 7.57828 4.81672C7.80436 4.62517 8.0762 4.3547 8.48064 3.95108L12.2202 0.21913C12.5134 -0.0734649 12.9883 -0.0729808 13.2809 0.220211C13.5735 0.513402 13.573 0.988276 13.2798 1.28087L9.54022 5.01282L9.51868 5.03432C9.14132 5.41093 8.82631 5.72531 8.54795 5.96116C8.25761 6.20717 7.95825 6.41133 7.59873 6.52798C7.04707 6.70698 6.45293 6.70698 5.90127 6.52798C5.54175 6.41133 5.24239 6.20717 4.95204 5.96116C4.67368 5.7253 4.35866 5.41091 3.98129 5.03429L3.95978 5.01282L0.220211 1.28087C-0.0729808 0.988276 -0.0734649 0.513402 0.21913 0.220211Z",
                      fill: "white",
                      fillRule: "evenodd",
                    },
                  ]}
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  position="absolute"
                >
                  
                    </Icon>   
                </MenuButton>}
                /// Arrow next  to user.name
              >
                
                <Flex
                height='50px'
                // backgroundColor="red"
                >
                
                <Text
                marginTop="15px"
                marginLeft="18px"
                color="black"
                
                > 
                {user?.attributes?.email}
                </Text>

                </Flex>

                <Divider />
  
               
              

  <MenuItem
  width='100%'
  height='50px'
  className=" hover:text-white"
  onClick={()=>{
    navAbout()
  }}
  
   >
    <Text
    fontWeight="normal"
    display="flex"
    // justifyContent="center"
    alignItems="center"
    className=" hover:text-white"
    width="100%"
    height="100%"
    // backgroundColor="red"
    
    >
    About
    </Text>
  </MenuItem>

 
  <MenuItem
  width='100%'
  height='50px'
  className=" hover:text-white"
  onClick={()=>{
    subscribenow()
  }}
  
   >
    <Text
    fontWeight="normal"
    display="flex"
    // justifyContent="center"
    alignItems="center"
    className=" hover:text-white"
    width="100%"
    height="100%"
    // backgroundColor="red"
    
    >
      {subscribed ? `Manage GateLeak Pro` : `Unlock All Agents!` }
    </Text>
  </MenuItem>


  {/* <Divider /> */}

  <MenuItem
  width='100%'
  height='50px'
   onClick={()=>{
    signOut()
  
   }}>
    Log out
  </MenuItem>
               
          
            </Menu>
            
          </Grid>

        

        <Modal
            isOpen={clickedProject}
            onRequestClose={closeProject}
            style={{
                overlay: {
                position: 'fixed',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.75)',
                zIndex: 999,
                padding: '20px'
                },
                content: {
                position: 'relative',
        //   display
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                border: '1px solid #ccc',
                
        //   background: 'blue',
        //   width: "302px",
        //   overflow: 'auto',
                backgroundColor:"rgba(222,136,101,.9",
                WebkitOverflowScrolling: 'touch',
                borderRadius: '20px',
                outline: 'none',
                padding: '30px'
                
                }
            }}
            >
              
              
              <Flex
              position="relative"
              justifyContent="center"
              alignItems="center"
              direction="column"
              textAlign="center"
              // backgroundColor="rgba(222,136,101,1"
              >
            {/* <ReactMarkdown> */}
            <Text
            position="relative"
            color="white"
            fontSize="20px"
            fontWeight="extrabold"
            // lineHeight="30px"
            // padding=" 20px 20px 20px 20px"
            >
              
                Select an Agent!
                

            </Text>
            
            
              </Flex>
              
              
        
            {/* <NewProject
            closeprojectmodal={closeModal}
            currentproject={currentproject}
            /> */}
            {/* <SignIn /> */}

        </Modal>
    </View>

  );
}
